import { useParams, resolvePath } from 'react-router-dom'

// Callback function when burst is available or change
export default (to) => {
  const { tenantKey } = useParams()
  return resolvePath(to, `/${tenantKey}`)
}
